import * as React from "react";
import { IdStyles } from "../../../less/IdStyles";
import { Icon } from "../../generic/icon/Icon";
import { IdIcon } from "../../generic/icon/IdIcon";
import { TimerCountdown } from "../../generic/timer/TimerCountdown";
export var OfferRemainingTime = function (_a) {
    var remainingSeconds = _a.remainingSeconds, className = _a.className;
    return (React.createElement("div", { className: "offer-timer-container-main offer-body__remaining-time " + (className || "") }, remainingSeconds !== -1 && (React.createElement("div", { className: "flex flex--guts" },
        React.createElement(Icon, { icon: IdIcon.TimeIcn, styleId: IdStyles.IconMedium }),
        React.createElement("div", { className: "pl__small" },
            React.createElement(TimerCountdown, { remainingTime: remainingSeconds, className: "" + IdStyles.TextBoldSecondaryOutline }))))));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/shop/components/OfferRemainingTime.tsx
// module id = 959
// module chunks = 3